import React from "react";

import "./Button.css";

import checkmarkImg from "../../assets/images/checkmark-white.png";

const Button = ({ disabled, color = 'bg-blue-500', children, img }) => {
  // return props.dis === "true" ? (
  //   <button className="cust-button-disabled uppercase" disabled type={props.type}>
  //     {props.text}
  //   </button>
  // ) : (
  //   <button className="cust-button uppercase" type={props.type}>
  //     {props.text} {props.img === "true" ? <img src={checkmarkImg} alt="checkmark" className="inline w-[22px] pl-[5px]" /> : null}
  //   </button>
  // );
  return (
    <button
      className={`rounded-md px-3 py-2 text-white font-medium border ${
        disabled
          ? "bg-gray-400 border-gray-400 cursor-not-allowed"
          : `${color} border-${color.replace("bg-", "")} cursor-pointer`
      } `}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;
